import type Feature from 'ol/Feature'

import CircleStyle from 'ol/style/Circle'
import { Fill, Stroke, Style } from 'ol/style'

import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon'
import Geometry from 'ol/geom/Geometry'

import { drawFeatureMetadata } from '../../utils/drawFeatureMetadata'
import { drawStyleCommon } from './common'

const common = drawStyleCommon()

export const invalidSketchPoint = new Style({
  image: new CircleStyle({
    radius: common.pointRadius,
    fill: new Fill({
      color: common.red(1),
    }),
    stroke: new Stroke({
      color: common.white(),
      width: common.pointBorderWidth,
    }),
  }),
  geometry: (feature: Feature<Geometry>) => {
    const invalid = drawFeatureMetadata.isInvalid(feature)

    if (!invalid) return

    // return the coordinates of the first ring of the polygon
    const geometry = feature?.getGeometry()
    if (geometry instanceof Geometry && geometry.getType() === 'Polygon') {
      const poly = geometry as Polygon
      const coordinates = poly.getCoordinates().at(0) ?? []

      const activeIndex = drawFeatureMetadata.getActiveIndex(feature)

      if (activeIndex > -1) {
        const sketchPoint = coordinates.at(activeIndex)
        if (!sketchPoint) return
        return new Point(sketchPoint)
      }
    }
  },
})
